import { MinusIcon, PlusIcon } from "@radix-ui/react-icons";
import React from "react";
import { TextField } from "@radix-ui/themes";
import {
  MAX_PRODUCT_QUANTITY_IN_ANY_UNIT,
  MIN_PRODUCT_COUNT,
} from "@/entities/annotation/model/consts";

interface CounterProps {
  value?: number;
  onIncrement: () => void;
  onDecrement: () => void;
  onValueChange: (value: number) => void;
}

const Counter: React.FC<CounterProps> = ({
  value,
  onIncrement,
  onDecrement,
  onValueChange,
}) => {
  return (
    <div className="flex items-center justify-between w-28 h-8 bg-gray-100 rounded-md">
      <button
        className="min-w-6 w-6 h-6 flex items-center justify-center bg-white rounded-md m-1 text-lg font-medium text-gray-500 hover:text-gray-700"
        onClick={onDecrement}
      >
        <MinusIcon />
      </button>
      <TextField.Root
        size="1"
        className="text-sm"
        value={value}
        onChange={(e) => {
          onValueChange(Number(e.target.value));
        }}
        onBlur={() => {
          if (value === undefined || isNaN(value) || value <= 0) {
            onValueChange(MIN_PRODUCT_COUNT);
          }

          if (
            value !== undefined &&
            !isNaN(value) &&
            value > MAX_PRODUCT_QUANTITY_IN_ANY_UNIT
          ) {
            onValueChange(MAX_PRODUCT_QUANTITY_IN_ANY_UNIT);
          }
        }}
      ></TextField.Root>
      <button
        className="min-w-6 w-6 h-6 flex items-center justify-center  bg-white rounded-md m-1 text-lg font-medium text-gray-500 hover:text-gray-700"
        onClick={onIncrement}
      >
        <PlusIcon />
      </button>
    </div>
  );
};

export default Counter;
